import React, { Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";

const style = theme => ({
  footer: {
    width: "100%",
    padding: 24
  },
  list: {
    listStyleType: "none",
    padding: 0,
    margin: 0,
    "& li": {
      padding: [[8, 8]],
      display: "inline-block"
    },
    "& a": {
      color: "rgba(0,0,0,0.87)",
      transition: "opacity 200ms ease-in-out",
      "&:visited": {
        color: "rgba(0,0,0,0.87)"
      },
      "&:hover": {
        color: "rgba(0,0,0,0.87)",
        opacity: 0.9
      }
    },
    "& span": {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: "1.46429em"
    }
  },
  fullWidth: {
    [theme.breakpoints.down("xs")]: {
      width: "100%"
    }
  }
});

const Footer = withStyles(style)(({ classes }) => (
  <Fragment>
    <hr className="divider" />
    <footer className={classes.footer}>
      <ul className={classes.list}>
        <li className={classes.fullWidth}>
          <span>© mondaybee 2018</span>
        </li>
        <li>
          <Link to="/About">
            <span>about us</span>
          </Link>
        </li>
        <li>
          <Link to={{ pathname: "/About", hash: "#contactus" }}>
            <span>contact us</span>
          </Link>
        </li>
        <li>
          <Link to={{ pathname: "/Faq" }}>
            <span>FAQ</span>
          </Link>
        </li>
        <li>
          <Link to={{ pathname: "/privacy-policy" }}>
            <span>privacy policy</span>
          </Link>
        </li>
        <li>
          <Link to={{ pathname: "/terms-and-conditions" }}>
            <span>terms and conditions</span>
          </Link>
        </li>
        {/* <li>
        <select>
          <option value="en">English</option>
          <option value="zh">中文</option>
        </select>
      </li> */}
      </ul>
    </footer>
  </Fragment>
));

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js